import {
  getInciList,
  updateInci,
  downloadInci
} from '@/axios/api/inciBasfMark'
const UPDATE_TABLE_DATA = 'UPDATE_TABLE_DATA'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_DETAIL = 'UPDATE_DETAIL'

const state = {
  tableData: [],
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  detail: {}
}

const getters = {
  tableData: state => state.tableData,
  pager: state => state.pager,
  detail: state => state.detail
}

const mutations = {
  [UPDATE_TABLE_DATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = { ...state.pager, ...pager }
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  }
}

const actions = {
  // 获取列表数据
  async getInciListApi ({ commit }, params) {
    try {
      const { data: res } = await getInciList(params)
      commit(UPDATE_TABLE_DATA, res.records)
      commit(UPDATE_PAGER, { total: res.total })
    } catch (e) {}
  },
  // 设置pager
  setPagerApi ({ commit }, params) {
    commit(UPDATE_PAGER, params)
  },
  // 编辑
  async updateInciApi ({ commit }, params) {
    try {
      await updateInci(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 下载
  async downloadInciApi ({ commit }, params) {
    try {
      const res = await downloadInci(params)
      return res || false
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/inciBasfMark.js